module.exports = __webpack_public_path__ + "static/whiteboard.70930c47.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/feathr/whiteboard.jpeg
// module id = 497
// module chunks = 33212578467737